import {composeReducers, createReducerFunction} from 'immer-reducer'
import defaultState from 'redux/totals/state'
import Totals from 'redux/totals/totals.duck'
import TotalsGridSession from 'redux/totals/gridSession.duck'

export default composeReducers(
  createReducerFunction(Totals, defaultState),
  createReducerFunction(TotalsGridSession, defaultState)
)
